export default __webpack_public_path__ + "static/media/Universidade_de_Sao_Paulo.1e3180a8.png";